export default __webpack_public_path__ + "static/media/onboardingAsideBgMb.60a56ba7.png";